import { UserJourney } from './types'

export type JourneyMarker = {
  journey: UserJourney
  esid: string
  handoff?: boolean
}

const ACTIVE_JOURNEY_MARKER_KEY = 'apt-uj-active-journey'

export const writeJourneyMarker = (journey: UserJourney, esid: string, handoff = false): void => {
  try {
    window.sessionStorage.setItem(ACTIVE_JOURNEY_MARKER_KEY, JSON.stringify({ journey, esid, ...(handoff ? { handoff: true } : {}) }))
  } catch {
    // marker is best-effort
  }
}

export const clearJourneyMarker = (): void => {
  try {
    window.sessionStorage.removeItem(ACTIVE_JOURNEY_MARKER_KEY)
  } catch {
    // marker is best-effort
  }
}

export const readJourneyMarker = (): JourneyMarker | undefined => {
  try {
    const raw = window.sessionStorage.getItem(ACTIVE_JOURNEY_MARKER_KEY)
    if (raw === null) {
      return undefined
    }
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null) {
      return undefined
    }
    const { journey, esid, handoff } = parsed as { journey?: Partial<UserJourney>; esid?: unknown; handoff?: unknown }
    if (typeof esid !== 'string' || typeof journey !== 'object' || journey === null) {
      return undefined
    }
    if (typeof journey.id !== 'string' || typeof journey.name !== 'string' || typeof journey.created !== 'number') {
      return undefined
    }
    return {
      esid,
      ...(handoff === true ? { handoff: true } : {}),
      journey: {
        id: journey.id,
        name: journey.name,
        created: journey.created,
        variant: typeof journey.variant === 'string' ? journey.variant : undefined,
        frustrations: Array.isArray(journey.frustrations) ? journey.frustrations : [],
        frictions: Array.isArray(journey.frictions) ? journey.frictions : [],
        tags: Array.isArray(journey.tags) ? journey.tags : [],
      },
    }
  } catch {
    return undefined
  }
}

export const markJourneyMarkerHandoff = (): void => {
  try {
    const marker = readJourneyMarker()
    if (marker !== undefined) {
      window.sessionStorage.setItem(ACTIVE_JOURNEY_MARKER_KEY, JSON.stringify({ ...marker, handoff: true }))
    }
  } catch {
    // marker is best-effort
  }
}
